import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type SelectedCountProps = StylableComponent<HTMLDivElement> & {
  count: number;
};

const SelectedCount = ({ count, style, ...props }: SelectedCountProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { tokens } = useTheme();
  const selectedCountTokens = tokens?.component?.footer?.selectedCount;

  return (
    <div
      css={[
        theme.typography.labelSmall,
        {
          display: 'flex',
          alignItems: 'center',
        },
        selectedCountTokens?._,
        style,
      ]}
      {...props}
    >
      {T.translate('SELECTED', {
        count,
      })}
    </div>
  );
};

export default SelectedCount;
